export default __webpack_public_path__ + "static/media/img-login.80d39e3b.png";